import _ from '../../core/utils'

const API_USER_SIGNIN_CONFIG = {
    form: _.select( '.form--user-signin' ),
    endpoint: 'user/signin/'
}
export default API_USER_SIGNIN_CONFIG